/* Maison Jouer — theme behaviour. No dependencies. */
(function () {
  'use strict';
  var MJ = window.MJ || {};
  var S = MJ.strings || {};

  function formatMoney(cents) {
    var fmt = MJ.moneyFormat || '${{amount}}';
    cents = typeof cents === 'string' ? cents.replace('.', '') : cents;
    function withDelims(n, precision, thousands, decimal) {
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelims(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      default: value = withDelims(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openLayer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    document.body.classList.add('is-locked');
    var panel = el.querySelector('[tabindex="-1"]');
    if (panel) panel.focus();
  }
  function closeLayer(el) {
    if (!el || el.hidden) return;
    el.hidden = true;
    document.body.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  var menu = document.getElementById('MenuDrawer');
  var cartDrawer = document.getElementById('CartDrawer');

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-menu-open]')) {
      openLayer(menu);
      var b = t.closest('[data-menu-open]'); b.setAttribute('aria-expanded', 'true');
    } else if (t.closest('[data-menu-close]')) {
      closeLayer(menu);
      var ob = document.querySelector('[data-menu-open]'); if (ob) ob.setAttribute('aria-expanded', 'false');
    } else if (t.closest('[data-cart-open]')) {
      if (!cartDrawer) return;
      e.preventDefault();
      refreshCart().then(function () { openLayer(cartDrawer); });
    } else if (t.closest('[data-drawer-close]')) {
      closeLayer(cartDrawer);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeLayer(cartDrawer); closeLayer(menu); }
  });

  /* ---------- Cart ---------- */
  function getCart() {
    return fetch(MJ.routes.cartJs, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function renderCart(cart) {
    if (!cartDrawer) return;
    var list = cartDrawer.querySelector('[data-cart-items]');
    var empty = cartDrawer.querySelector('[data-cart-empty]');
    var foot = cartDrawer.querySelector('[data-cart-foot]');
    var sub = cartDrawer.querySelector('[data-cart-subtotal]');
    document.querySelectorAll('[data-cart-count]').forEach(function (n) {
      n.textContent = cart.item_count;
      n.hidden = cart.item_count === 0;
    });
    if (!cart.item_count) {
      list.innerHTML = '';
      list.hidden = true; foot.hidden = true; empty.hidden = false;
      return;
    }
    list.hidden = false; foot.hidden = false; empty.hidden = true;
    list.innerHTML = cart.items.map(function (item, i) {
      var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=300' : '';
      var variant = item.product_has_only_default_variant ? '' : '<p class="small">' + esc(item.variant_title) + '</p>';
      return '<div class="cart-item">' +
        (img ? '<img class="cart-item__img" src="' + esc(img) + '" alt="" loading="lazy" width="96" height="128">' : '') +
        '<div class="cart-item__info">' +
          '<a class="cart-item__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' + variant +
          '<p class="small">' + formatMoney(item.final_line_price) + '</p>' +
          '<div class="cart-item__row">' +
            '<div class="qty"><button type="button" class="qty__btn" aria-label="Decrease quantity" data-line="' + (i + 1) + '" data-qty-to="' + (item.quantity - 1) + '">−</button>' +
            '<span class="qty__input" aria-label="Quantity">' + item.quantity + '</span>' +
            '<button type="button" class="qty__btn" aria-label="Increase quantity" data-line="' + (i + 1) + '" data-qty-to="' + (item.quantity + 1) + '">+</button></div>' +
            '<button type="button" class="link-btn" data-line="' + (i + 1) + '" data-qty-to="0">' + esc(S.remove || 'Remove') + '</button>' +
          '</div>' +
        '</div></div>';
    }).join('');
    sub.textContent = formatMoney(cart.total_price);
  }
  function refreshCart() { return getCart().then(renderCart).catch(function () {}); }

  if (cartDrawer) {
    cartDrawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line]');
      if (!b) return;
      b.disabled = true;
      fetch(MJ.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(b.dataset.line), quantity: Math.max(0, Number(b.dataset.qtyTo)) })
      }).then(function (r) { return r.json(); }).then(renderCart).catch(function () { b.disabled = false; });
    });
  }

  /* ---------- Product ---------- */
  var section = document.querySelector('[data-product-section]');
  if (section) {
    var jsonEl = section.querySelector('[data-product-json]');
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var form = section.querySelector('[data-product-form]');
    var idInput = section.querySelector('[data-variant-id]');
    var addBtn = section.querySelector('[data-add-btn]');
    var priceEl = section.querySelector('[data-price]');
    var errEl = section.querySelector('[data-form-error]');
    var sticky = section.querySelector('[data-sticky-atc]');
    var stickyAdd = section.querySelector('[data-sticky-add]');
    var stickyVariant = section.querySelector('[data-sticky-variant]');
    var stickyPrice = section.querySelector('[data-sticky-price]');

    function selectedOptions() {
      return Array.prototype.map.call(section.querySelectorAll('[data-option-index]'), function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function currentVariant() {
      if (!product) return null;
      var opts = selectedOptions();
      if (!opts.length) return product.variants[0];
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      }) || null;
    }
    function markAvailability() {
      if (!product) return;
      var opts = selectedOptions();
      section.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var idx = Number(fs.dataset.optionIndex);
        fs.querySelectorAll('input').forEach(function (input) {
          var trial = opts.slice(); trial[idx] = input.value;
          var ok = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return trial[i] == null || o === trial[i]; });
          });
          var label = fs.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !ok);
        });
        var c = fs.querySelector('input:checked');
        var out = fs.querySelector('[data-option-selected]');
        if (out) out.textContent = c ? c.value : '';
      });
    }
    function update() {
      var v = currentVariant();
      if (errEl) errEl.hidden = true;
      markAvailability();
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = S.soldOut || 'Unavailable';
        return;
      }
      idInput.value = v.id;
      priceEl.textContent = formatMoney(v.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      if (stickyVariant) stickyVariant.textContent = product.variants.length > 1 ? v.title + ' · ' : '';
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? (S.addToBag || 'Add to bag') : (S.soldOut || 'Sold out');
      if (stickyAdd) { stickyAdd.disabled = !v.available; stickyAdd.textContent = addBtn.textContent; }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      if (v.featured_media) {
        var slide = section.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        var track = section.querySelector('[data-gallery]');
        if (slide && track && window.matchMedia('(max-width: 989px)').matches) {
          track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
      }
    }
    section.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) update();
    });

    var qty = section.querySelector('[data-qty]');
    section.addEventListener('click', function (e) {
      if (e.target.closest('[data-qty-minus]')) qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
      if (e.target.closest('[data-qty-plus]')) qty.value = (parseInt(qty.value, 10) || 1) + 1;
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!currentVariant()) {
          errEl.textContent = S.chooseSize || 'Please choose an option.'; errEl.hidden = false; return;
        }
        addBtn.disabled = true;
        var fd = new FormData(form);
        fetch(MJ.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            addBtn.disabled = false;
            if (!res.ok) {
              errEl.textContent = res.body.description || S.error; errEl.hidden = false; return;
            }
            return getCart().then(function (cart) {
              renderCart(cart);
              var live = cartDrawer && cartDrawer.querySelector('[data-cart-live]');
              if (live) live.textContent = S.added || 'Added.';
              openLayer(cartDrawer);
            });
          })
          .catch(function () { addBtn.disabled = false; errEl.textContent = S.error; errEl.hidden = false; });
      });
    }

    if (stickyAdd && form) {
      stickyAdd.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
      });
    }
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var hidden = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', hidden);
        sticky.setAttribute('aria-hidden', hidden ? 'false' : 'true');
        if (stickyAdd) stickyAdd.tabIndex = hidden ? 0 : -1;
      }).observe(addBtn);
    }

    var track = section.querySelector('[data-gallery]');
    var idxEl = section.querySelector('[data-gallery-index]');
    if (track && idxEl) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        idxEl.textContent = i + 1;
      }, { passive: true });
    }
    markAvailability();
  }
})();
